import { render, staticRenderFns } from "./AdminHealthcheckDevice.vue?vue&type=template&id=21edcb83&scoped=true&"
import script from "./AdminHealthcheckDevice.vue?vue&type=script&lang=js&"
export * from "./AdminHealthcheckDevice.vue?vue&type=script&lang=js&"
import style0 from "./AdminHealthcheckDevice.vue?vue&type=style&index=0&id=21edcb83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21edcb83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21edcb83')) {
      api.createRecord('21edcb83', component.options)
    } else {
      api.reload('21edcb83', component.options)
    }
    module.hot.accept("./AdminHealthcheckDevice.vue?vue&type=template&id=21edcb83&scoped=true&", function () {
      api.rerender('21edcb83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminHealthcheckDevice.vue"
export default component.exports